<template>
    <v-card>
        <v-card-title class="text-xs-center">
            <v-btn @click="$emit('onclose')">Close</v-btn>
        </v-card-title>
        <v-card-text>
            <h3>You can copy following report and email to our Sales Admin. to update TAZ System.</h3>

            <div>
            --------------------------------------------------------------------------------------------------------------------------------------------
            </div>
            <div>State: {{state}}</div>
            <div>
            --------------------------------------------------------------------------------------------------------------------------------------------
            </div>
            <div v-for="trz in tazTerrXRepsXZips" :key="trz.territoryXRepId">
                <div v-if="trz.zips.some(p=>p.changed)">
                    <v-layout row>
                        <v-flex xs12>
                            <div class="">
                                Territory: {{trz.territoryId}}
                                /
                                Rep.: {{trz.repName}}
                                /
                                12 Months Sales: {{ trz.terrRepSalesAmt | toCurrency}}
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12>
                            <div><b>New ZIPs assigned:</b></div>
                            <span v-for="zipData in trz.zips" :key="zipData.zip" v-show="zipData.changed">
                                {{zipData.zip}},
                            </span>
                        </v-flex>
                    </v-layout>
                        
                    <div>
                    --------------------------------------------------------------------------------------------------------------------------------------------
                    </div>

                </div>

            </div>

        </v-card-text>

    </v-card>
</template>
<script>
export default {
    props: ['tazTerrXRepsXZips', 'state']
}
</script>